import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../ui/Button';

export const CtaSection = () => {
  return (
    <section className="py-24 bg-meetoi-navy relative overflow-hidden">
      {/* Background Decorative Curve */}
      <svg className="absolute w-full h-full top-0 left-0 opacity-20 pointer-events-none" viewBox="0 0 1440 400" fill="none">
        <path d="M-100 400 C 300 200, 800 300, 1500 100" stroke="#BFE3E8" strokeWidth="2" strokeDasharray="8 8" />
        <circle cx="200" cy="280" r="4" fill="#BFE3E8" />
        <circle cx="800" cy="270" r="4" fill="#E97862" />
        <circle cx="1200" cy="150" r="4" fill="#1985A1" />
      </svg>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10 bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-12 rounded-[2rem]">
          <div className="text-center md:text-left">
            <h2 className="font-sora text-3xl md:text-4xl font-bold text-white leading-tight mb-4">
              Ready to turn connections into opportunities?
            </h2>
            <p className="font-manrope text-base text-meetoi-aqua/80 font-medium">
              Join thousands of professionals who are building stronger relationships with Meetoi.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto shrink-0">
            <Link to="/register" className="w-full sm:w-auto">
              <Button size="lg" className="w-full sm:w-auto bg-white text-meetoi-navy hover:bg-meetoi-offwhite rounded-xl px-8 py-4 font-manrope font-bold border-0">
                Create your Meetoi card
              </Button>
            </Link>
            <Link to="/login" className="w-full sm:w-auto">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto bg-transparent text-white border-white/30 hover:bg-white/10 rounded-xl px-8 py-4 font-manrope font-bold">
                Log in
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};